/* Created by Chintan on 30/8/16.
*/
'use strict';
import constantData from '../../common/constants.js';

export default class loginController {
	constructor(UserLoginService,$state){
		this.MsgBlock = false;
		this.errorMessage = '';
		var that = this;
		this.checkLogin = (AdminLogin)=>{
			if(AdminLogin.$valid){
				var postData = {'userName':this.userName, 'password':this.password};
				UserLoginService.verifyLogin(postData).then(function(result){
					if(result){
						$state.go('app.categories');
					}
					else{
						that.MsgBlock = true;
						that.errorMessage = 'Invalid username or password.'
					}
				}, function(err){
					if(err){
						console.log('Error');
						this.MsgBlock = true;
						this.errorMessage = 'Invalid username or password.'
					}
				});
			}
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/modules/authentication/login.controller.js